<template lang="pug">
  v-content
    v-container
      v-app-bar.elevation-1(flat color='white')
        v-toolbar-title Edit Request
        v-spacer
        v-btn(color='primary' to='/my-permit') My Permit
      AddKetinggian(v-if="$route.name === 'Edit Izin Kerja Di Ketinggian'" edit)
      AddKelistrikan(v-if="$route.name === 'Edit Izin Kerja Kelistrikan'" edit)
      AddIzinRuangTerbatas(v-if="$route.name === 'Edit Izin Kerja Ruang Terbatas'" edit)
      AddKerjaPanas(v-if="$route.name === 'Edit Izin Kerja Dengan Panas'" edit)
      AddRemoteArea(v-if="$route.name === 'Edit Izin Kerja Remote Area'" edit)
      AddRadioaktif(v-if="$route.name === 'Edit Izin Kerja Radioaktif'" edit)
      AddIzinPenggalian(v-if="$route.name === 'Edit Izin Kerja Penggalian'" edit)
      AddPeledakan(v-if="$route.name === 'Edit Izin Kerja Peledakan'" edit)
      AddPengawalan(v-if="$route.name === 'Edit Izin Kerja Pengawalan'" edit)
      AddNewLampiranPengawalan(v-if="$route.name === 'Edit Lampiran Izin Kerja Pengawalan Unit'" edit)
      AddIzinTamu(v-if="$route.name === 'Edit Izin Tamu'" edit)
      AddJangkaPendek(v-if="$route.name === 'Edit Izin Kerja Jangka Pendek'" edit)
      AddProyek(v-if="$route.name === 'Edit Izin Melaksanakan Kegiatan Proyek'" edit)
      AddJasa(v-if="$route.name === 'Edit Izin Melaksanakan Kegiatan Usaha Jasa'" edit)
      AddUsulanPerubahan(v-if="$route.name === 'Edit Izin Usulan Perubahan'" edit)
      
</template>

<script>
import AddKetinggian from "../components/AddKetinggian.vue";
import AddKelistrikan from "../components/AddKelistrikan.vue";
import AddKerjaPanas from "../components/AddKerjaPanas";
import AddRemoteArea from '@/components/AddRemoteArea.vue';
import AddIzinRuangTerbatas from '@/components/AddIzinRuangTerbatas.vue';
import AddRadioaktif from '@/components/AddRadioaktif.vue';
import AddIzinPenggalian from "../components/AddIzinPenggalian.vue";
import AddPeledakan from "../components/AddPeledakan.vue";
import AddPengawalan from "../components/AddPengawalan.vue";
import AddNewLampiranPengawalan from "../components/AddNewLampiranPengawalan";
import AddIzinTamu from "../components/AddIzinTamu.vue";
import AddJangkaPendek from "../components/AddJangkaPendek.vue"
import AddProyek from "../components/AddProyek.vue";
import AddJasa from "../components/AddJasa.vue";
import AddUsulanPerubahan from "../components/AddUsulanPerubahan.vue";
import { mapState } from "vuex";
export default {
  name: "EditForm",
  components: {
    AddKetinggian,
    AddKelistrikan,
    AddKerjaPanas,
    AddRemoteArea,
    AddIzinRuangTerbatas,
    AddRadioaktif,
    AddIzinPenggalian,
    AddPeledakan,
    AddNewLampiranPengawalan,
    AddPengawalan,
    AddIzinTamu,
    AddJangkaPendek,
    AddProyek,
    AddJasa,
    AddUsulanPerubahan
  },
  data () {
    return {
      dialog: false,
      // users: [],
    }
  },
  computed: {
    ...mapState(["API_URL", 'permitHolder', "fetchDataEditRequests"])
  },
  mounted() {
    this.$store.dispatch("fetchLocations");
    // this.$store.dispatch("fetchPermitHolder").then(() => {
    //   this.users = this.permitHolder;
    // });
    let query = '';
    if (this.$route.name === 'Edit Lampiran Izin Kerja Pengawalan Unit') {
      query = 'fetchDataEditAttachments';
    } else {
      query = 'fetchDataEditRequests';
    }

    this.$store.dispatch(query, this.$route.params.id);
  }
};
</script>